import React from "react";
import { UserStats } from "../types";
import { RankingItem } from "./RankingItem";
import { EmptyState } from "./EmptyState";

interface RankingListProps {
  pizzaiolos: UserStats[];
  maxItems?: number;
}

export const RankingList: React.FC<RankingListProps> = ({
  pizzaiolos,
  maxItems = 12,
}) => {
  if (pizzaiolos.length === 0) {
    return <EmptyState />;
  }

  return (
    <div className="flex-1 space-y-1.5 overflow-y-auto sm:space-y-2">
      {pizzaiolos.slice(0, maxItems).map((pizzaiolo, index) => (
        <RankingItem
          key={`${pizzaiolo.nome}-${pizzaiolo.sobrenome}-${index}`}
          pizzaiolo={pizzaiolo}
          index={index}
        />
      ))}
    </div>
  );
};
